import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Haze as Hanger, Shirt, CalendarDays, Compass, User } from 'lucide-react';

const tabs = [
  { path: '/closet', label: 'Closet', icon: Hanger },
  { path: '/tryon', label: 'Try On', icon: Shirt },
  { path: '/planner', label: 'Planner', icon: CalendarDays },
  { path: '/discover', label: 'Discover', icon: Compass },
  { path: '/profile', label: 'Profile', icon: User },
] as const;

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = tabs.find((tab) =>
    location.pathname.startsWith(tab.path),
  );

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-xl
                 border-t border-vestir-gray shadow-nav safe-bottom"
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="max-w-lg mx-auto flex items-center justify-around px-2 py-2">
        {tabs.map((tab) => {
          const isActive = activeTab?.path === tab.path;
          const Icon = tab.icon;

          return (
            <button
              key={tab.path}
              onClick={() => {
                if (isActive) {
                  // Re-clicking the active tab resets the view (e.g., back to list from detail)
                  navigate(tab.path, { replace: true, state: { reset: Date.now() } });
                } else {
                  navigate(tab.path);
                }
              }}
              className="relative flex flex-col items-center justify-center w-14 h-14
                         rounded-xl transition-colors"
              aria-label={tab.label}
              aria-current={isActive ? 'page' : undefined}
            >
              {isActive && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute inset-0 bg-vestir-purple/10 rounded-xl"
                  transition={{ type: 'spring', stiffness: 500, damping: 35 }}
                />
              )}

              <Icon
                size={22}
                className={`relative z-10 transition-colors ${
                  isActive ? 'text-vestir-purple' : 'text-vestir-gray-dark'
                }`}
                strokeWidth={isActive ? 2.5 : 2}
              />

              <span
                className={`relative z-10 text-[10px] mt-1 font-medium transition-colors ${
                  isActive ? 'text-vestir-purple' : 'text-vestir-gray-dark'
                }`}
              >
                {tab.label}
              </span>

              {isActive && (
                <motion.div
                  layoutId="activeDot"
                  className="absolute -top-1 w-1 h-1 bg-vestir-purple rounded-full"
                  transition={{ type: 'spring', stiffness: 500, damping: 35 }}
                />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
